import BossModel from "@/models/BossModel";
import Row from "@/models/PlatinumPage/Version/Element/Row/Row";
import Element from "@/models/PlatinumPage/Version/Element/Element";

export default class Column extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-page/version/element/row/column';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumPageVersionElementRowColumns';

    static fields() {
        return {
            id: this.number(null).nullable(),
            rank: this.number(null).nullable(),
            width: this.number(null).nullable(),
            platinum_page_version_element_row_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            row: this.belongsTo(Row, 'platinum_page_version_element_row_id'),
            elements: this.hasMany(Element, 'platinum_page_version_element_row_column_id'),
        }
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    ActualWidthPercentage() {
        let parentPercentage = 100;
        if (this.Row().Element().Column()) {
            parentPercentage = 100 / 12 * this.Row().Element().Column().width;
        }

        return (parentPercentage / 12 * this.width).toFixed(0);
    }

    /**
     *
     * @param column
     * @param rows
     * @returns {boolean}
     */
    static updateElementRanks(column, rows) {
        for (let key in rows) {
            if (Object.prototype.hasOwnProperty.call(rows, key) && rows[key].id !== undefined) {

                // check if widget can be placed in this column
                if (rows[key] instanceof Element && rows[key].Widget()) {
                    if (!rows[key].Widget().WidgetTemplate().FitsInColumn(column)) {
                        return false;
                    }
                }

                rows[key].rank = key;
                rows[key].platinum_page_version_element_row_column_id = column.id;
                rows[key].platinum_page_version_container_id = null;
                rows[key].api().update();
            }
        }

        return true;
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Row() {
        return this.getRelated('row');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Elements() {
        return this.getRelated('elements');
    }
}
